/**
 * External Imports
 */
import { FC, useCallback } from 'react';
import { connect } from 'react-redux';

/**
 * Internal Imports
 */
import SupportListSettingsTable from './supportListSettingsTable/SupportListSettingsTable';

import { RootState } from '../../../../redux/store';
import {
  useGetEmployeeSubjectConfigQuery,
  useUpdateSubjectHiddenStatusMutation
} from '../../../../redux/apis/Users.api';

import { useFeatures } from '../../../../services/Features/features';
import { useUserRolesRef } from '../../../../services/UserRoles';

/**
 * Global Type Definition Imports
 */
import { CSCEmployee } from '../../../../config/interfaces';

interface CSCListSettingsProps {
  facilityId: string;
  userId: string;
}

const CSCListSettingsTable: FC<CSCListSettingsProps> = ({
  facilityId,
  userId
}) => {
  const {
    isCSCRounder,
    isEnterpriseAdmin,
    isNonSupportRounder,
    isTemplateConfigurator,
    isUserAdmin
  } = useUserRolesRef();

  const { isCSCEnabled } = useFeatures();

  const {
    data: cscEmployeesData,
    // isError: isGetEmployeeSubjectConfigError,
    // isFetching: isGetEmployeeSubjectConfigFetching,
    isLoading: isGetEmployeeSubjectConfigLoading
  } = useGetEmployeeSubjectConfigQuery(
    { employeeId: userId, roundingType: 'csrn' },
    {
      skip: !isCSCEnabled || !userId
    }
  );
  const [
    updateSubjectHiddenStatus
    // {
    //   isError: isUpdateSubjectHiddenStatusError,
    //   isLoading: isUpdateSubjectHiddenStatusLoading,
    //   isSuccess: isUpdateSubjectHiddenStatusSuccess
    // }
  ] = useUpdateSubjectHiddenStatusMutation();

  const hideEmployee = useCallback(
    (employee: CSCEmployee) => {
      updateSubjectHiddenStatus({
        employeeId: employee.hcaid,
        facilityId,
        roundingType: 'csrn',
        userId,
        visible: !employee.visible
      });
    },
    [facilityId, userId]
  );

  return (
    <SupportListSettingsTable
      employees={cscEmployeesData}
      isFacilitySelectorEnabled={
        isEnterpriseAdmin ||
        (isCSCRounder &&
          !(isNonSupportRounder || isTemplateConfigurator || isUserAdmin))
      }
      isTableEnabled={isCSCEnabled}
      loadingSupportList={isGetEmployeeSubjectConfigLoading}
      type="csc"
      hideEmployee={hideEmployee}
    />
  );
};

const mapReduxStateToProps = (state: RootState) => {
  return {
    facilityId: state.AuthorizedUser.authorizedUser.facilityId,
    userId: state.AuthorizedUser.authorizedUser.hcaid
  };
};

export default connect(mapReduxStateToProps)(CSCListSettingsTable);
